import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { SeguridadService } from '../service/seguridad.service';

@Directive({
  selector: '[appWriteAction]',
})
export class WriteActionDirective implements OnInit, OnDestroy {
  private readonly subscription = new Subscription();

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private seguridadService: SeguridadService
  ) {}

  ngOnInit(): void {
    this.updateVisibility();
    this.subscription.add(
      this.seguridadService.user$.subscribe(() => this.updateVisibility())
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateVisibility(): void {
    this.renderer.setProperty(
      this.elementRef.nativeElement,
      'hidden',
      this.seguridadService.isReadOnly()
    );
  }
}
